/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import {
  FieldValues, Path, UseFormReturn, useFieldArray,
} from 'react-hook-form';

interface Props<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
}

export function BeneficiaryListField<T extends FieldValues>({ form, name }: Props<T>) {
  const { control, register } = form;
  const { fields, append, remove } = useFieldArray({ control, name: name as never });

  return (
    <div className="border rounded p-2">
      {fields.length === 0 && (
        <p className="text-muted small mb-2">Sin beneficiarios.</p>
      )}

      {fields.map((field, index) => (
        <div key={field.id} className="row g-2 align-items-end mb-2">
          <div className="col-md-4">
            <label className="form-label small mb-1">Fecha de nacimiento</label>
            <input
              type="date"
              className="form-control form-control-sm"
              {...register(`${name}.${index}.date_of_birth` as Path<T>)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small mb-1">Duración (años)</label>
            <input
              type="number"
              step="1"
              className="form-control form-control-sm"
              onWheel={(e) => e.currentTarget.blur()}
              {...register(`${name}.${index}.duration_years` as Path<T>)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small mb-1">Arancel anual (UF)</label>
            <input
              type="number"
              step="any"
              className="form-control form-control-sm"
              onWheel={(e) => e.currentTarget.blur()}
              {...register(`${name}.${index}.annual_tuition` as Path<T>)}
            />
          </div>
          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => remove(index)}
            >
              Quitar
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={() => append(
          { date_of_birth: '2015-06-01', duration_years: 5, annual_tuition: 120 } as never,
        )}
      >
        + Agregar beneficiario
      </button>
    </div>
  );
}
